import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Zoom } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Card from './Card';
import { NextPrevArrow } from '../helper/Icons';

function SwiperSlider({ sectionHeading, icon, data }) {
    const swiperRef = useRef(null);

    return (
        <div className="wrapper mx-auto my-4">
            <div className='d-flex justify-content-between align-items-center mb-4'>
                <h2 className='text-white fs-22 fw-bold m-0'>
                    <span className='opacity-50 me-2'>{icon}</span>{sectionHeading}
                </h2>
                <div className='d-flex align-items-center gap-2'>
                    <button
                        className="btn bg-darkslate max-w-h-33 d-flex p-1"
                        onClick={() => swiperRef.current?.slidePrev()}
                    >
                        <NextPrevArrow />
                    </button>
                    <button
                        className="btn bg-darkslate rotate-180 max-w-h-33 d-flex p-1"
                        onClick={() => swiperRef.current?.slideNext()}
                    >
                        <NextPrevArrow />
                    </button>
                </div>
            </div>
            <Swiper
                modules={[Navigation]}
                onBeforeInit={(swiper) => {
                    swiperRef.current = swiper;
                }}
                slidesPerView={2.2}
                spaceBetween={8}
                breakpoints={{
                    475: {
                        slidesPerView: 3.2,
                        spaceBetween: 20,
                    },
                    640: {
                        slidesPerView: 4.2,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 5.2,
                    },
                    1024: {
                        slidesPerView: 6,
                    },
                }}
                className="mySwiper"
            >
                {data.map((data, index) => (
                    <SwiperSlide key={index}>
                        <Card
                            img={data.img}
                            headingpart1={data.headingpart1}
                            headingpart2={data.headingpart2}
                            pera={data.pera}
                            bgColor={data.bgColor}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

export default SwiperSlider;